import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./App.css";

function LoginModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const role = docSnap.data().role;
        onClose();

        if (role === "tutor") {
          navigate("/tutor-dashboard");
        } else {
          navigate("/student-dashboard");
        }
      } else {
        setErrorMsg("User profile not found.");
      }
    } catch (error) {
      console.error("Login error:", error.code);
      if (error.code === "auth/invalid-credential") {
        setErrorMsg("❌ Incorrect email or password.");
      } else {
        setErrorMsg("❌ " + error.message);
      }
    }
  };

  return (
    <div style={styles.overlay}>
      <motion.div
        style={styles.modal}
        onClick={(e) => e.stopPropagation()}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        <div style={styles.header}>
          <h2 style={styles.headerText}>⭐ Sign In ⭐</h2>
        </div>

        <form onSubmit={handleLogin} style={styles.form}>
          {errorMsg && <div style={styles.error}>{errorMsg}</div>}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />
          <div style={styles.actions}>
            <button type="submit" style={styles.loginButton}>Sign In</button>
            <button type="button" onClick={onClose} style={styles.cancelButton}>Cancel</button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },
  modal: {
    width: "380px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 15px 35px rgba(0,0,0,0.3)",
    overflow: "hidden"
  },
  header: {
    backgroundColor: "#007bff",
    padding: "1rem 1.5rem",
  },
  headerText: {
    color: "white",
    margin: 0,
    fontSize: "1.4rem",
  },
  form: {
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  error: {
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "0.75rem",
    borderRadius: "6px",
    fontSize: "0.9rem",
  },
  input: {
    padding: "0.75rem",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
    boxShadow: "inset 0 0 4px rgba(0,123,255,0.2)",
    outline: "none",
  },
  actions: {
    marginTop: "1rem",
    display: "flex",
    justifyContent: "flex-end",
    gap: "0.75rem",
  },
  loginButton: {
    backgroundColor: "#007bff",
    color: "white",
    padding: "0.6rem 1.2rem",
    border: "none",
    borderRadius: "6px",
    fontSize: "1rem",
    fontWeight: "bold",
    boxShadow: "0 4px 10px rgba(0,123,255,0.4)",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "#f1f1f1",
    color: "#333",
    padding: "0.6rem 1.2rem",
    border: "none",
    borderRadius: "6px",
    fontSize: "1rem",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  },
};

export default LoginModal;
